module.exports = __webpack_public_path__ + "img/colour-logo-transparent-bg.c47f1685.png";